export interface LoraReceipt {
  idrec: number;
  eui: string;
  createtime: any;
  sent: boolean;
}

export class LoraReceiptDetails {
  constructor(
    public idrec: number,
    public data: string,
    public fport: number,
    public response: string,
    public transcript: any,
    public commandName: string
  ) {}
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/interfaces/lora-receipt.ts